// extracted by mini-css-extract-plugin
export default {"overlay":"cR_kx","container":"cR_d","header":"cR_c9","logo":"cR_fT","title":"cR_c0","closeButton":"cR_fP","closeButtonIcon":"cR_hz"};